// extracted by mini-css-extract-plugin
export default {"twitterHeart":"#f91880","twitterWhite":"#fff","badgerBlue":"#1c2c42","discord":"#8435bde8","desktopGap":"80px","maxContainerWidthLarge":"1080px","maxContainerWidthMed":"768px"};